import { cloudApiClient } from '@/services/clientSideCloudApiService';

export async function createSupportTicket(subject: string, description: string) {
  await cloudApiClient.post('ticket', { subject, description });
}
